/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-lines-per-function */
import { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Toolbar } from 'primereact/toolbar'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { MultiSelect } from 'primereact/multiselect'
import { Button } from 'primereact/button'
import { useSelector } from 'react-redux'
import { Checkbox } from 'primereact'
import importVanBangProcessor from '../../../processor/importVanBangProcessor'
import ImportModal from '../../../components/form/ImportModal'
import { getGioiTinh, mapGioiTinh } from '../../../constant/gioiTinh'
import { checkVanBangIsValid } from '../../../constant/vanBangState'
import { exportExcel } from '../../../utils/excel'
import XacNhanChuyen from './XacNhanChuyen'
import ComboDropdownKhoaThi from '../../../components/form/ComboDropdownKhoaThi'
import ListVanBang from '../ListVanBang'
import { dateToDDMMYY, ExcelDateToJSDate } from '../../../utils/date'
import namProcessor from '../../../processor/namProcessor'
import khoaThiProcessor from '../../../processor/khoaThiProcessor'

const colsTemp = [
  'TT',
  'Hoten',
  'Gioitinh',
  'Ngaysinh',
  'Noisinh',
  'Dantoc',
  // 'HK',
  // 'HL',
  // 'Mon1',
  // 'Mon2',
  // 'Mon3',
  // 'Mon4',
  // 'Mon5',
  // 'Mon6',
  // 'Diemmon1',
  // 'Diemmon2',
  // 'Diemmon3',
  // 'Diemmon4',
  // 'Diemmon5',
  // 'Diemmon6',
  // 'Ketqua',
  'Xeploai',
  // 'Ma_DKThi',
  // 'Ten_DKThi',
  'Mã trường Tốt nghiệp',
  'Tên trường tốt nghiệp',
  'Năm tốt nghiệp',
  // 'Hoidong',
  'Sohieu',
  'Socapbang',
  'HeDaoTao',
  'HinhThucDaoTao',
  'MaTruongTHCS',
  // 'TenTruongTHCS',
  'CCCD',
  'GhiChu',
]

function NamKhoaThi() {
  const khoaThiId = useSelector((state) => state.khoaThi.id)
  const namId = useSelector((state) => state.nam.id)
  const listNam = useSelector((state) => state.nam.datas)
  const listKhoaThi = useSelector((state) => state.khoaThi.datas)
  return (
    <div className="flex flex-column">
      <div className="field">
        <p>Năm:</p>
        <div>
          <Dropdown
            optionLabel="name"
            optionValue="id"
            options={listNam}
            value={namId}
            disabled
            className="w-full"
          />
        </div>
      </div>
      <div className="field">
        <p>Khoá thi:</p>
        <div>
          <Dropdown
            optionLabel="name"
            optionValue="id"
            options={listKhoaThi}
            value={khoaThiId}
            disabled
            className="w-full"
          />
        </div>
      </div>
    </div>
  )
}

function ImportVanBang() {
  const moduleTitle = 'Import danh sách văn bằng'
  const processor = importVanBangProcessor

  const [paging, setPaging] = useState({ skip: 0, take: 10, total: 0 })
  const [validState, setValidState] = useState(0)
  const [name, setName] = useState('')
  const [datas, setDatas] = useState([])
  const [importNhieu, setImportNhieu] = useState(false)

  const khoaThiId = useSelector((item) => item.khoaThi.id)
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)

  const getVanBang = async () => {
    if (khoaThiId) {
      const rs = await processor.getByKhoaThi({ khoaThiId, ...paging })
      setPaging({
        skip: rs.totalItemsCount === 0 ? 0 : rs.skip,
        take: rs.take,
        total: rs.totalItemsCount,
      })
      setDatas(rs.values)
    }
  }

  const onSubmit = async (data) => {
    let nams = []
    let khoaThis = []
    if (importNhieu) {
      nams = await namProcessor.getAll()
      khoaThis = await khoaThiProcessor.getAll()
    }
    const submitData = data.map((item) => {
      // let namDt
      // let khoaThiDt
      // if (importNhieu) {
      // namDt = nams.find((it) => it.name.toString() === item['Năm tốt nghiệp'].toString())
      // if (!namDt) return {}
      // khoaThiDt = khoaThis.find((it) => it.namId === namDt.id)
      // if (!khoaThiDt) return {}
      // }
      const newItem = {
        HoTen: item.Hoten,
        Gioitinh: mapGioiTinh(item.Gioitinh),
        NgaySinh:
          typeof item.Ngaysinh === 'number'
            ? dateToDDMMYY(ExcelDateToJSDate(item.Ngaysinh))
            : item.Ngaysinh,
        NoiSinh: item.Noisinh,
        DanToc: item.Dantoc,
        HanhKiem: item.HK,
        HocLuc: item.HL,
        KetQua: true,
        SoHieu: item.Sohieu,
        SoCapBang: item.Socapbang,
        XepLoai: item.Xeploai,
        GhiChu: item.GhiChu,
        KhoaThiId: khoaThiId,
        'Năm tốt nghiệp': item['Năm tốt nghiệp'],
        cccd: item.CCCD,
        wsname: item.wsname,
      }

      for (let i = 1; i <= 6; i++) {
        const nameMon = `Mon${i}`
        const nameDiemMon = `DiemMon${i}`
        const nameDiemMonExcel = `Diemmon${i}`
        newItem[nameMon] = item[nameMon]
        newItem[nameDiemMon] = item[nameDiemMonExcel]
      }

      newItem.HeDaoTao = { code: item.HeDaoTao || 'Ko' }
      newItem.HinhThucDaoTao = { code: item.HinhThucDaoTao || 'Ko' }
      newItem.Truong = { code: item.MaTruongTHCS || 'Ko' }
      // newItem.HoiDong = { code: item['Mã trường Tốt nghiệp'] || 'Ko' }
      // newItem.DonViDangKyDuThi = { code: item.Ma_DKThi || 'Ko' }
      newItem.DonViDangKyDuThi = { code: item['Mã trường Tốt nghiệp'] || 'Ko' }
      Object.keys(newItem).forEach((key) => {
        if (typeof newItem[key] === 'string' && key !== 'SoHieu' && key !== 'SoCapBang') {
          newItem[key] = newItem[key].trim()
        }
      })
      return newItem
    })
    if (importNhieu) {
      const loiNam = submitData.find((item) => !item[['Năm tốt nghiệp']])
      if (loiNam) {
        toast({ type: 'error', message: `Sheet ${loiNam.wsname} có dữ liệu lỗi` })
        return
      }
      for (const n of nams) {
        const khoaThiDt = khoaThis.find((it) => it.namId === n.id)
        const dataByKt = submitData
          .filter((item) => item['Năm tốt nghiệp'].toString() === n.name.toString())
          .map((item) => {
            return { ...item, KhoaThiId: khoaThiDt.id }
          })
        if (dataByKt.length > 0) {
          const rs = await processor.import(dataByKt, khoaThiDt.id)
          toast({
            type: rs.isSuccess ? 'success' : 'error',
            message: `Tải dữ liệu khoá thi ${khoaThiDt.name} ${
              rs.isSuccess ? 'thành công' : 'thất bại'
            }`,
          })
        }
      }
    } else {
      const rs = await processor.import(submitData, khoaThiId)
      toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
      if (rs.isSuccess) getVanBang()
    }
  }

  const deleteOnClick = async () => {
    if (document.getElementById('btn-lamlai')) document.getElementById('btn-lamlai').disabled = true
    if (document.getElementById('btn-xacnhan'))
      document.getElementById('btn-xacnhan').disabled = true
    if (document.getElementById('btn-xuat-excel'))
      document.getElementById('btn-xuat-excel').disabled = true
    const rs = await processor.deleteImport(khoaThiId)
    if (document.getElementById('btn-lamlai'))
      document.getElementById('btn-lamlai').disabled = false
    if (document.getElementById('btn-xacnhan'))
      document.getElementById('btn-xacnhan').disabled = false
    if (document.getElementById('btn-xuat-excel'))
      document.getElementById('btn-xuat-excel').disabled = false
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) setDatas([])
  }

  const deleteOneOnClick = async (id) => {
    if (confirm) {
      const rs = await processor.delete(id)
      toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
      if (rs.isSuccess) setDatas([...datas.filter((item) => item.id !== id)])
    }
  }
  const column = [
    {
      value: 'soHieu',
      name: 'Số hiệu',
    },
    {
      value: 'soCapBang',
      name: 'Số cấp bằng',
    },
    {
      value: 'hoTen',
      name: 'Họ tên',
    },
    {
      value: 'gioiTinh',
      name: 'Giới tính',
      render: (item) => getGioiTinh(item.gioiTinh),
    },
    {
      value: 'ngaySinh',
      name: 'Ngày sinh',
    },
    {
      value: 'noiSinh',
      name: 'Nơi sinh',
    },
    {
      value: 'danToc',
      name: 'Dân tộc',
    },
    {
      value: 'hocLuc',
      name: 'Học lực',
    },
    {
      value: 'hanhKiem',
      name: 'Hạnh kiểm',
    },
    {
      value: 'xepLoai',
      name: 'Xếp loại',
    },
    {
      value: 'ngayCapBang',
      name: 'Ngày cấp bằng',
    },
    {
      value: 'ngayKy',
      name: 'Ngày ký',
    },
    {
      value: 'nguoiKy',
      name: 'Người ký',
    },
    {
      value: 'ketQua',
      name: 'Kết quả',
      render: (item) => {
        return (
          <div className="flex justify-content-center">
            {item.ketQua ? <i className="pi pi-check" /> : <i className="pi pi-times" />}
          </div>
        )
      },
    },
    {
      value: 'heDaoTao',
      name: 'Hệ đào tạo',
      render: (item) => (item.heDaoTao ? item.heDaoTao.name : ''),
    },
    {
      value: 'hinhThucDaoTao',
      name: 'Hình thức đào tạo',
      render: (item) => (item.hinhThucDaoTao ? item.hinhThucDaoTao.name : ''),
    },
    {
      value: 'donViDangKyDuThi',
      name: 'Trường tốt nghiệp',
      render: (item) => (item.donViDangKyDuThi ? item.donViDangKyDuThi.name : ''),
    },
    // {
    // value: 'hoiDong',
    // name: 'Hội đồng',
    // render: (item) => (item.hoiDong ? item.hoiDong.name : ''),
    // },
    { value: 'truong', name: 'Trường', render: (item) => (item.truong ? item.truong.name : '') },
    {
      value: 'state',
      name: 'Hiệu lực',
      alignHeader: 'center',
      render: (item) => {
        return (
          <div className="flex justify-content-center">
            {checkVanBangIsValid(item.state) ? (
              <i className="pi pi-check" />
            ) : (
              <i className="pi pi-times" />
            )}
          </div>
        )
      },
    },
    { value: 'invalidMessage', name: 'Thông tin lỗi' },
    {
      value: 'cn',
      name: 'Chức năng',
      alignHeader: 'center',
      render: (data) => {
        return (
          <div className="flex justify-content-center">
            <Button
              icon="pi pi-trash"
              className="p-button-rounded p-button-danger mr-2"
              onClick={() => {
                confirm({
                  action: () => deleteOneOnClick(data.id),
                  body: `Bạn có muốn xoá văn bằng này`,
                })
              }}
              tooltip="Xoá"
              tooltipOptions={{ position: 'top' }}
            />
          </div>
        )
      },
    },
  ]

  const validStates = [
    { label: 'Tất cả', value: 0 },
    { label: 'Hợp lệ', value: 2 },
    { label: 'Không hợp lệ', value: 1 },
  ]

  const mappingExport = {
    hoTen: 'Họ tên',
    gioiTinh: 'Giới tính',
    ngaySinh: 'Ngày sinh',
    soHieu: 'Số hiệu',
    soCapBang: 'Số vào sổ',
  }

  const [selectedColumns, setSelectedColumns] = useState([
    'truong',
    'soHieu',
    'soCapBang',
    'hoTen',
    'state',
    'invalidMessage',
    'cn',
  ])
  return (
    <>
      <div className="flex flex-column">
        <div className="flex justify-content-between">
          <h4>{moduleTitle}</h4>
          <div className="flex vanbang-seacher-cotainer">
            <ImportModal
              template="/excel/temp/VanBangBanChinh.xlsx"
              onSubmit={onSubmit}
              colsTemp={colsTemp}
              importFirstSheet={!importNhieu}
            >
              <NamKhoaThi colsTemp={colsTemp} />
              <div className="flex align-items-center mb-3">
                <Checkbox checked={importNhieu} onChange={(e) => setImportNhieu(e.checked)} />
                <label className="ml-2">Import nhiều năm</label>
              </div>
            </ImportModal>
            <XacNhanChuyen datas={datas} khoaThiId={khoaThiId} onDone={() => setDatas([])} />
            <div>
              <Button
                id="btn-lamlai"
                icon="pi pi-times"
                className="p-button-danger ml-2 mb-2"
                onClick={() => {
                  confirm({
                    action: deleteOnClick,
                    body: `Bạn có muốn xoá dữ liệu đã import`,
                  })
                }}
                disabled={datas.length === 0}
                label="Làm lại"
              />
            </div>
            <div>
              <Button
                id="btn-xuat-excel"
                type="button"
                icon="pi pi-file-excel"
                className="p-button-success ml-2 mb-2"
                onClick={() => exportExcel(datas, 'danhSachDaImport', mappingExport)}
                disabled={datas.length === 0}
                label="Xuất excel"
              />
            </div>
          </div>
        </div>
        <div className="card">
          <Toolbar
            className="mb-4"
            left={
              <div className="flex mb-2">
                <MultiSelect
                  value={selectedColumns}
                  options={column}
                  optionLabel="name"
                  onChange={(event) => setSelectedColumns(event.value)}
                  style={{ width: '20em' }}
                />
              </div>
            }
            right={
              <div className="flex vanbang-seacher-cotainer">
                <span className="p-input-icon-right mr-2 mb-2">
                  <InputText
                    value={name}
                    type="text"
                    placeholder="Tìm theo tên, số hiệu,..."
                    onChange={(e) => setName && setName(e.target.value)}
                  />
                  <i className="pi pi-search" />
                </span>
                <div>
                  <Dropdown
                    options={validStates}
                    value={validState}
                    onChange={(e) => setValidState(e.value)}
                    className="mr-2 mb-2"
                  />
                </div>
                <ComboDropdownKhoaThi />
              </div>
            }
          />
          <ListVanBang
            processor={processor}
            column={column.filter((item) => selectedColumns.find((s) => s === item.value))}
            khoaThiId={khoaThiId}
            datas={datas}
            setDatas={setDatas}
            paging={paging}
            setPaging={setPaging}
            state={validState}
            name={name}
            getMethod={processor.getByKhoaThi}
          />
        </div>
      </div>
    </>
  )
}

export default withRouter(ImportVanBang)
